// About.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaPython, FaReact } from "react-icons/fa";
import { SiTensorflow, SiTailwindcss } from "react-icons/si";

export default function About() {
  const points = [
    {
      title: "Python Backend",
      content: "OpenCV + TensorFlow process gestures efficiently.",
      icon: <FaPython className="w-16 h-16 text-blue-600" />,
    },
    {
      title: "TensorFlow",
      content: "Handles real-time gesture recognition.",
      icon: <SiTensorflow className="w-16 h-16 text-orange-600" />,
    },
    {
      title: "React Frontend",
      content: "Responsive UI using React.js.",
      icon: <FaReact className="w-16 h-16 text-cyan-500" />,
    },
    {
      title: "Tailwind CSS",
      content: "Styled with Tailwind for modern, clean UI.",
      icon: <SiTailwindcss className="w-16 h-16 text-teal-500" />,
    },
  ];

  const colors = ["bg-pink-200/80", "bg-indigo-200/80", "bg-green-200/80", "bg-yellow-200/80"];

  return (
    <section className="relative w-full min-h-screen bg-gray-100 py-20 flex flex-col items-center">
      <h2 className="text-4xl font-bold mb-20 z-10 relative text-center">
        Tech Stack of the Project
      </h2>

      <div className="relative w-full max-w-5xl flex flex-col gap-40">
        {points.map((point, idx) => {
          const isLeft = idx % 2 === 0;

          return (
            <motion.div
              key={idx}
              className="relative w-full flex"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: idx * 0.2 }}
            >
              {/* Bubble with only text */}
              <div className={`w-full flex ${isLeft ? "justify-start" : "justify-end"}`}>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className={`${colors[idx]} w-72 h-72 rounded-full p-6 flex flex-col justify-center items-center text-center shadow-2xl cursor-pointer transition-all duration-300 relative z-10`}
                >
                  <h3 className="font-bold text-xl mb-3">{point.title}</h3>
                  <p className="text-gray-800 text-sm">{point.content}</p>
                </motion.div>
              </div>

              {/* Connector line */}
              <svg className="absolute w-full h-full pointer-events-none">
                <line
                  x1={isLeft ? "25%" : "75%"}
                  y1="50%"
                  x2={isLeft ? "75%" : "25%"}
                  y2="50%"
                  stroke="#ccc"
                  strokeWidth="2"
                  strokeDasharray="6"
                />
              </svg>

              {/* Tech icon at end of line */}
              <div
                className={`absolute top-1/2 transform -translate-y-1/2 ${
                  isLeft ? "right-[22%]" : "left-[22%]"
                }`}
              >
                {point.icon}
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
